import { UploadingDocument } from 'candidate_profile_redesign/shared/types';
import type { Action, Reducer, State } from '../use_candidate_profile';

export const documentReducer: Reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'addUploadingDocument': {
      return {
        ...state,
        uploadingDocuments: [...state.uploadingDocuments, ...action.payload],
      };
    }
    case 'deleteUploadingDocument': {
      return {
        ...state,
        uploadingDocuments: state.uploadingDocuments.filter(
          (doc) =>
            !action.payload.map((d: UploadingDocument) => d.id).includes(doc.id)
        ),
      };
    }
    default: {
      return state;
    }
  }
};
